import {
  GET_USERS_LIST,
  GET_USERS_LIST_SUCCESS,
  GET_USERS_LIST_FAILURE,
} from "../actionTypes";

export const getUsersList = (payload) => ({
  type: GET_USERS_LIST,
  payload,
});

export const getUsersListSuccess = (payload) => ({
  type: GET_USERS_LIST_SUCCESS,
  payload,
});

export const getUsersListFailure = () => ({
  type: GET_USERS_LIST_FAILURE,
});
